export default "__VITE_ASSET__faddd905__"